import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ThemeService {
  private readonly THEME_KEY = 'appTheme';
  private readonly BODY_CLASS = 'dark-theme';
  private themeSubject: BehaviorSubject<string>;

  constructor() {
    const storedTheme = localStorage.getItem(this.THEME_KEY) || 'light';
    this.themeSubject = new BehaviorSubject<string>(storedTheme);
    this.applyStoredTheme();
  }

  get themes() {
    return this.themeSubject.asObservable();
  }

  private applyStoredTheme() {
    const storedTheme = this.getTheme();
    document.documentElement.setAttribute('data-theme', storedTheme);
    this.toggleBodyClass(storedTheme);
  }

  getTheme(): string {
    return localStorage.getItem(this.THEME_KEY) || 'light';
  }

  toggleTheme() {
    const currentTheme = this.getTheme();
    const newTheme = currentTheme === 'light' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', newTheme);
    localStorage.setItem(this.THEME_KEY, newTheme);
    this.themeSubject.next(newTheme);
    this.toggleBodyClass(newTheme);
  }

  private toggleBodyClass(theme: string) {
    document.body.classList.remove(this.BODY_CLASS);
    if (theme === 'dark') {
      document.body.classList.add(this.BODY_CLASS);
    }
  }
}
